import React from 'react';

export default function BlankLayout(props) {
    const { children } = props;

    return <React.Fragment>{children}</React.Fragment>;
}
